// Installed iOS home-screen apps that ran the pre-SEC-2368 service worker kept
// a broken response for each resource video they played in their own WebKit
// HTTP cache. CloudFront serves media `max-age=31536000, immutable`, so that
// entry outlives the service worker fix and is shared by the in-app browser
// ("Open in New Tab"). A distinct cache key makes iOS fetch the file fresh.
// Bump the key only if a cached copy of the media goes bad again.
export const MEDIA_CACHE_KEY = 'pwa2';

const MEDIA_EXTENSION = /\.(mp4|m4v|mov|webm|ogv|ogg|mp3|m4a|aac|wav)$/i;

export const withMediaCacheKey = (url) => {
  if (!url || typeof url !== 'string') return url;
  try {
    const parsed = new URL(url);
    if (!/^https?:$/.test(parsed.protocol) || !MEDIA_EXTENSION.test(parsed.pathname)) return url;
    parsed.searchParams.set('v', MEDIA_CACHE_KEY);
    return parsed.toString();
  } catch {
    return url;
  }
};
